module.exports = __webpack_public_path__ + "img/20191211163825963.3b64e022.jpg";